module.exports = __webpack_public_path__ + "img/banner-r-main.954ff17f.png";